import React, { useState } from "react";
import PlayerLiveScore from "@/components/common/PlayerLiveScore";
import PlayerCount from "@/components/common/playerCount";

const LiveBanner = ({
  playerCount,
  score,
  streak,
  avatar
}) => {
  return (<>
    <div className="flex justify-between w-full my-1">
      { playerCount !== 0 ? <PlayerCount count={playerCount}/> : null }
      { score >= 0 && streak >= 0 ? <PlayerLiveScore score={score} streak={streak} avatar={avatar}/> : null }
    </div>
  </>)
};

export default LiveBanner;
